angular.module("datasets")

    .controller("DatasetsExportCtrl", ['$uibModalInstance', 'LoginService', '$scope', 'id', 'type', 'options', '$stateParams', 'Restangular', '$filter', 'logService',
        function ($uibModalInstance, LoginService, $scope, id, type, options, $stateParams, Restangular, $filter, logService) {

            $scope.dataset_id = id;
            $scope.configuration = null;
            $scope.datasets = null;
            $scope.fileType = { value: "xlsx"};
            $scope.fileTypeOptions = [
                //{ name: "csv", translation: $filter('translate')('datasets.export_csv') },
                { name: "xlsx", translation: $filter('translate')('datasets.export_xlsm') },
                { name: "pdf", translation: $filter('translate')('datasets.export_pdf') },
            ];

            //Comprobamos si tiene permiso escritura
            $scope.allowExport = LoginService.permissionExist("DATASETS_EXPORT");

            $scope.options = options; 
            console.log(options);
            logService.debug('options');
            logService.debug(options);

            // Lo metemos en el filtro
            $scope.useFilter = false;
            $scope.toggleFilter = function () {
                if ($scope.useFilter) {
                    $scope.useFilter = false;
                } else {
                    $scope.useFilter = true;
                }
            }

            // Controlamos si hemos venido desde una exportación completa de grupo 
            var recursiveElementId = null;
            if (options && options.recursiveElementId) {
                recursiveElementId = options.recursiveElementId;
            } 

            //Obtenemos información de configuracion de exportación
            logService.debug("DatasetsExportCtrl", id, type, options);
            $scope.loadExportConfig = function (dataset_id) {
                var data = {
                    options: options
                };
                Restangular.all('Datasets').customPOST(data, "ExportConfig", { id: dataset_id}).then(function (result) {
                //Restangular.all('Datasets').customGET("ExportConfig", { id: dataset_id, options: $scope.options }).then(function (result) {
                    $scope.configuration = result;
                    console.log($scope.configuration);
                    logService.debug(result);
                });
            };

            if (id != null) {
                $scope.loadExportConfig(id);
            } else if (type != null) {
                Restangular.all('Datasets').getList({ type: type }).then(function (result) {
                    $scope.datasets = result;
                    logService.debug(result);
                });
            }

            $scope.onDatasetChange = function (dataset) {
                $scope.dataset_id = dataset.id;
                $scope.loadExportConfig(dataset.id);
            };

            $scope.onExport = function () {
                logService.debug($scope.fileType);
                logService.debug($scope.options);

                var data = {
                    id: $scope.configuration.id,
                    name: $scope.configuration.name,
                    columns: $scope.configuration.columns,
                    options: options
                };

                // Controlamos desde aquí si se usa el filtro o no
                if (!$scope.useFilter) {
                    if (data.options != null) {
                        data.options.FILTERED_IDS = null;
                    }
                }

                logService.debug(data);
                console.log(data);
                var settings = {
                    id: $scope.dataset_id,
                    fileType: $scope.fileType.value,
                    recursiveElementId: options!=null?options.recursiveElementId:null
                }

                Restangular.all('Datasets').customPOST(data, "Export", { id: $scope.dataset_id, fileType: $scope.fileType.value, recursiveElementId: recursiveElementId }).then(function (result) {
                    $scope.exportResult = result;
                    $scope.getSize();
                });
            };

            $scope.getSize = function () {
                var result = "";
                if ($scope.exportResult.size < 1024) {
                    result = $scope.exportResult.size + " bytes";
                }else if ($scope.exportResult.size < (1024 * 1024)) {
                    result = $filter('number')($scope.exportResult.size / 1024, 2) + "Kb";
                } else {
                    result = $filter('number')($scope.exportResult.size / 1024 / 1024, 2) + "Mb";
                }
                $scope.exportResult.size_description = result;
            };

            $scope.onDownload = function () {
                var url = "/api/datasets/download/" + $scope.exportResult.code + "?fileName=" + $scope.exportResult.name;
                window.open(url);
                $uibModalInstance.close();
            };

            $scope.onCancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

        }]);

